__webpack_require__.p = "/dev/graphic-2/";